export default __webpack_public_path__ + "static/media/mars43.aa694eca.gif";